import React from "react";
import { Truck, Leaf, ShieldCheck, Scissors } from "lucide-react";
import { Reveal, useReveal } from "./_shared";

const VALUES = [
  { icon: Scissors, title: "Hand finished", body: "Tailored in batches of forty across our Ahmedabad atelier." },
  { icon: Truck, title: "Free shipping", body: "Complimentary delivery across India. Dispatched in 48 hours." },
  { icon: Leaf, title: "Plastic-free", body: "Recycled cotton bags, soy-ink labels. Always." },
  { icon: ShieldCheck, title: "15-day returns", body: "Easy exchange or refund on unworn pieces, no questions." },
];

export default function ValueProps() {
  const ref = useReveal(0.15);
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <Reveal className="text-center mb-14">
        <p className="eyebrow">Our Promise</p>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-3">
          What sits in your wardrobe should outlast a season.
        </h2>
      </Reveal>
      <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 reveal-stagger">
        {VALUES.map((v) => {
          const Icon = v.icon;
          return (
            <div
              key={v.title}
              className="border border-[#1A1A1A]/15 bg-[#b8af92] p-7 md:p-8 lift-card group cursor-default"
            >
              <Icon size={28} className="text-[#1A1A1A] group-hover:scale-110 transition-transform duration-500" />
              <h3 className="font-serif-display text-2xl mt-5">{v.title}</h3>
              <p className="text-[13px] text-[#1A1A1A]/70 mt-2 leading-relaxed">{v.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
